<template>
  <v-ons-col>
    <v-ons-row class="color-chart-text">
      <v-ons-col class="color-chart-min">暗い</v-ons-col>
      <v-ons-col class="color-chart-max">明るい</v-ons-col>
    </v-ons-row>
    <div class="color-chart" />
  </v-ons-col>
</template>

<script>
export default {
};
</script>

<style scoped lang="scss">
.color-chart {
  margin-left: 1em;
  margin-right: 1em;
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,ffede8+9,ffead1+18,ffe8b9+27,ffe5a2+36,ffe38b+45,ffe074+55,ffee5d+64,ffeb46+73,ffe92e+82,ffe617+91,ffe400+100 */
  background: #ffffff; /* Old browsers */
  background: -moz-linear-gradient(left,  #ffffff 0%, #ffede8 9%, #ffead1 18%, #ffe8b9 27%, #ffe5a2 36%, #ffe38b 45%, #ffe074 55%, #ffee5d 64%, #ffeb46 73%, #ffe92e 82%, #ffe617 91%, #ffe400 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(left,  #ffffff 0%,#ffede8 9%,#ffead1 18%,#ffe8b9 27%,#ffe5a2 36%,#ffe38b 45%,#ffe074 55%,#ffee5d 64%,#ffeb46 73%,#ffe92e 82%,#ffe617 91%,#ffe400 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to right,  #ffffff 0%,#ffede8 9%,#ffead1 18%,#ffe8b9 27%,#ffe5a2 36%,#ffe38b 45%,#ffe074 55%,#ffee5d 64%,#ffeb46 73%,#ffe92e 82%,#ffe617 91%,#ffe400 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}
</style>



// WEBPACK FOOTER //
// brightness.vue?184dbafe